<template>
  <div id="paso3">
    <paso-actual />
    <div class="row">
      <div class="col">
        <p class="p-3">Hemos recibido tus datos. <br />
          Estaremos en contacto a la brevedad.
        </p>
      </div>
    </div>

    <div class="row mt-2">
      <div class="col-6">
        <button class="btn btn-primary btn-sm ml-4" @click="finalizar" :disabled="!finalizado">Finalizado</button>
        <span v-if="!finalizado" class="ml-2"><i class="fas fa-spinner fa-spin mr-2"></i>espere...</span>
        <span v-if="finalizado">Listo!</span>
      </div>
    </div>
  </div>
</template>

<script>
  import EventBus from '../EventBus';
  import PasoActual from './PasoActual';

  export default {
    data: () => ({
      finalizado: false
    }),
    methods: {
      finalizar: function() {
        this.$store.dispatch('postulante/clearData');
        //this.$emit('continuar', 1);
        window.location.href = "http://www.clinicaparque.com.ar";
      }
    },
    activated() {
      this.$store.commit('pasos/setPasoActivo', 4);
    },
    mounted() {
      //do something after mounting vue instance
      EventBus.$on('FINALIZADO', (data) => {
        this.finalizado = true;
      })
    },
    components: {
      'paso-actual': PasoActual
    }
  }
</script>

<style lang="sass" scoped>
</style>



// WEBPACK FOOTER //
// src/components/Paso4.vue